import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { DocumentTypesListComponent } from '../../document-types-list/document-types-list.component';
import { IMilestone, MILESTONE_TYPE } from '../../../../../@core/models/model';
import { ToastService } from '../../../../../@core/services/toast.service';
import { DialogComponent } from '../../../../../@core/components/ui/dialog/dialog.component';
import { MileStoneService } from '../../../../services/milestone.service';
import { DocumentTypeFilter, DocumentTypeService } from '../../../../services/document-type.service';
import { KNOWLEDGE_BASE_SVG } from '../../knowledgebase/knowledge-base-svg';
import { SanitizeHtmlPipe } from "../../../../../@shared/pipes/sanitizeHtml.pipe";
import { IDocumentType } from '../../../../models/settings.model';
import { ButtonComponent } from "../../../../../@core/components/ui/button/button.component";
import { DeleteConfirmationComponent } from "../../../../../@core/components/ui/delete-confirmation/delete-confirmation.component";



@Component({
    selector: 'app-document-milestone',
    imports: [
        CommonModule,
        FormsModule,
        DatePickerModule,
        CheckboxModule,
        ButtonModule,
        InputGroupModule,
        InputGroupAddonModule,
        SkeletonModule,
        TooltipModule,
        MenuModule,
        DocumentTypesListComponent,
        DialogComponent,
        SanitizeHtmlPipe,
        ButtonComponent,
        DeleteConfirmationComponent
    ],
    standalone: true,
    templateUrl: './document-milestone.component.html',
    styleUrl: './document-milestone.component.scss'
})
export class DocumentMilestoneComponent implements OnInit {

    constructor(
        private toastService: ToastService,
        private milestoneService: MileStoneService,
        private documentTypeService: DocumentTypeService
    ) { }

    selectedDocType!: IDocumentType;
    addEditMilestoneVisible: boolean = false;
    edit: boolean = false;
    newMilestoneName: string = ''
    statusLoading: boolean = false
    milestoneOptions: IMilestone[] = []
    selectedMilestone: IMilestone | null = null;
    docTypeLoading: boolean = false;
    docTypes: IDocumentType[] = []
    SVGS = KNOWLEDGE_BASE_SVG;
    deleteMilestoneDialog: boolean = false;


    ngOnInit() {
        this.getDocumentTypes()
    }


    getDocumentTypes() {
        this.docTypeLoading = true;
        this.documentTypeService.getDocTypes([DocumentTypeFilter.GENERAL, DocumentTypeFilter.FORM_RELATED]).subscribe(res => {
            if (res && res.success) {
                this.docTypeLoading = false;
                this.docTypes = res.data;
            } else {
                this.docTypeLoading = false;
            }
        });
    }

    onDocumentTypeSelected(docType: IDocumentType) {
        this.selectedDocType = docType
        this.getMilestoneForDocType();
    }

    getMilestoneForDocType() {
        this.milestoneService.getMilestones(MILESTONE_TYPE.DOCUMENT, undefined, undefined, this.selectedDocType._id).subscribe(res => {
            if (res && res.success) {
                this.statusLoading = false
                this.milestoneOptions = res.data
            }
        })
    }

    addMilestone() {
        this.newMilestoneName = '';
        this.edit = false;
        this.addEditMilestoneVisible = true;
    }

    editMilestone(milestone: IMilestone): void {
        this.edit = true;
        this.selectedMilestone = milestone;
        this.newMilestoneName = milestone.name
        this.addEditMilestoneVisible = true;
    }



    openDeleteDialog(milestone: IMilestone) {
        this.selectedMilestone = milestone
        this.deleteMilestoneDialog = true
    }

    deleteSelectedMilestone() {
        this.milestoneService.deleteMilestone(this.selectedMilestone?._id || '').subscribe(res => {
            if (res && res.success) {
                this.toastService.success("Milestone deleted successfully.")
                this.getMilestoneForDocType()
                this.deleteMilestoneDialog = false;
            }
        })
    }

    cancelAddMilestone(): void {
        this.addEditMilestoneVisible = false;
        this.newMilestoneName = '';
        this.edit = false;
        this.selectedMilestone = null;
    }

    saveNewMilestone(): void {
        if (this.newMilestoneName && this.newMilestoneName.trim()) {
            if (this.edit && this.selectedMilestone) {
                this.updateDocumentTypeMilestone()
            } else {
                this.createDocumentTypeMilestone()
            }
        }
    }

    createDocumentTypeMilestone() {
        this.milestoneService.addMilestone(this.newMilestoneName, MILESTONE_TYPE.DOCUMENT, this.selectedDocType._id).subscribe(res => {
            if (res && res.success) {
                this.toastService.success('Document type milestone successfully created.')
                this.addEditMilestoneVisible = false;
                this.newMilestoneName = '';
                this.getMilestoneForDocType()
            }
        })
    }

    updateDocumentTypeMilestone() {
        this.milestoneService.updateMilestone(this.newMilestoneName, this.selectedMilestone?._id || '', MILESTONE_TYPE.DOCUMENT, this.selectedDocType._id).subscribe(res => {
            if (res && res.success) {
                this.toastService.success('Document type milestone successfully updated.')
                this.addEditMilestoneVisible = false;
                this.edit = false;
                this.newMilestoneName = '';
                this.getMilestoneForDocType();
            }
        });
    }

    get hasChanges(): boolean {
        if (!this.edit) return this.newMilestoneName.length > 0;
        return this.newMilestoneName.trim() !== this.selectedMilestone?.name?.trim();
    }
}
